<template>
  <div class="ctn_nav">
    <!-- {{ _modules }} -->
    <ul>
      <li>
        <div class="list_item">
          <router-link :to="{ name: 'PanelHome' }">
            <div
              class="mask"
              :class="['PanelHome' == getNav ? 'active' : 'normal']"
              @click="actionNav('PanelHome')"
            >
              <v-icon>mdi-rhombus</v-icon>
              <span>Panel</span>
            </div>
          </router-link>
        </div>
      </li>
      <li v-for="(item, i) in organizedModule" :key="`${item._id}-${i + 1}`">
        <div
          class="list_item"
          v-if="item.checkModule === true && item.visible === true"
        >
          <router-link :to="{ name: item.route }">
            <div
              class="mask"
              :class="[item.route == getNav ? 'active' : 'normal']"
              @click="actionNav(item.route)"
            >
              <v-icon>{{ item.icon }}</v-icon>
              <span>{{ item.nameModule }}</span>
            </div>
          </router-link>
        </div>
      </li>
      <li v-for="(item, i) in _modules" :key="`${item._id}-2${i + 1}`">
        <div
          class="list_item"
          v-if="item.nameModule == 'Dispositivos' && item.visible === true"
        >
          <router-link :to="{ name: 'NotifyHome' }">
            <div
              class="mask"
              :class="['NotifyHome' == getNav ? 'active' : 'normal']"
              @click="actionNav('NotifyHome')"
            >
              <div v-if="getNotify.check > 0" class="circle_noty">
                <span>{{ getNotify.check }}</span>
              </div>
              <v-icon>mdi-bell </v-icon>
              <span>Alertas</span>
            </div>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Nav",
  props: {
    _id: {
      type: String,
    },
    _modules: {
      type: Array,
    },
  },
  mounted() {
    if (this.isLogin) {
      this.panelNotify();
    }
  },
  methods: {
    ...mapActions(["actionNav", "panelNotify"]),
  },
  computed: {
    ...mapGetters(["getNav", "getNotifyDeviceNumber", "getPanel", "getNotify"]),
    organizedModule() {
      let moduleOrganize = _.sortBy(this._modules, ["obj", "nameModule"]);
      return moduleOrganize;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/base.scss";
.ctn_nav {
  @media #{$phone-down} {
    display: none;
  }
  border: 1px solid #ddd;
  border-radius: 10px;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      &:last-child {
        .list_item {
          border-bottom: 1px solid transparent;
        }
      }
      .list_item {
        min-width: 80px;
        border-bottom: $custom-border;
      }
      a {
        text-decoration: none;
        .mask {
          position: relative;
          margin: 1px;
          padding: 15px 10px;
          display: flex;
          flex-direction: column;
          color: $color-text-grey;
          transition-duration: 0.28s;
          transition-property: background-color, transform, opacity;
          &:hover {
            border-radius: 4px;
            background-color: rgb(248, 248, 248);
            color: #000;
            text-decoration: none;
            i {
              color: #000;
            }
          }
          &.normal {
            color: $color-text-grey;
          }
          &.active {
            margin: 1px;
            border-radius: 4px;
            background-color: $dark-jungle-green;
            font-weight: 500;
            color: $text-green-light;
            i {
              color: $text-green-light;
            }
            span {
              color: $text-green-light;
            }
            .circle_noty {
              border: none;
            }
          }
          .circle_noty {
            position: absolute;
            border: 2px solid #fff;
            top: 10px;
            right: 24px;
            padding: 1px;
            z-index: 1;
            height: 18px;
            min-width: 18px;
            background-color: #fc3d21;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            span {
              padding: 0;
              text-align: center;
              font-size: 0.7rem;
              color: #fff;
            }
          }
          span {
            font-size: 0.7rem;
            text-align: center;
          }
          i {
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>
